

export class AddDocumentTypeAddInput implements IAddDocumentTypeAddInput {
    /** The document type name with 255 character limit */
    documentTypeName!: string;

    constructor(data?: IAddDocumentTypeAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeName = _data["documentTypeName"];
        }
    }

    static fromJS(data: any): AddDocumentTypeAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddDocumentTypeAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeName"] = this.documentTypeName;
        return data; 
    }
}

export interface IAddDocumentTypeAddInput {
    /** The document type name with 255 character limit */
    documentTypeName: string;
}

